import { SectionProps } from './types'
import SecureInput from '../../../ui/SecureInput/SecureInput'
import { Link as LinkIcon, Key, Lock } from 'lucide-react'

export default function OAuthClientCredentialsSection({ form, styles }: SectionProps) {
  const { watch, setValue } = form
  return (
    <>
      <div className={styles.field}>
        <SecureInput
          fieldType="url"
          label="Token URL"
          icon={<LinkIcon size={16} />}
          value={watch('oauth.token_url') || ''}
          onChange={(value) => setValue('oauth.token_url', value)}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="key"
          label="Client ID"
          icon={<Key size={16} />}
          value={watch('oauth.client_id') || ''}
          onChange={(value) => setValue('oauth.client_id', value)}
          autoComplete="new-client-id"
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="password"
          label="Client Secret"
          icon={<Lock size={16} />}
          value={watch('oauth.client_secret') || ''}
          onChange={(value) => setValue('oauth.client_secret', value)}
          autoComplete="new-password"
          skipPasswordValidation={true}
          className={styles.input}
        />
      </div>

      <div className={styles.field}>
        <SecureInput
          fieldType="text"
          label="Scope"
          value={watch('oauth.scope') || ''}
          onChange={(value) => setValue('oauth.scope', value)}
          className={styles.input}
        />
      </div>
    </>
  )
}
